import { useAiAssistantAdminContext } from "./ai-assistant-admin-context";
import { SettingsSection } from "./settings-section";

/** Sub menu "Umum": satu form saklar, nama, kepribadian, batas pemakaian, kiosk, suara, dan plafon. */
export function UmumPage() {
	const { overview, disabled, applySettings } = useAiAssistantAdminContext();
	return (
		<SettingsSection
			settings={overview.settings}
			kioskCandidates={overview.kioskCandidates}
			transcriptRetentionDays={overview.transcriptRetentionDays}
			disabled={disabled}
			onSaved={applySettings}
		/>
	);
}
